export default class Utils {
    /**
     * 数値の配列に重複しない乱数を追加して取得
     * @param {number} min 範囲の最小値
     * @param {number} max 範囲の最大値
     * @param {number[]} numArr 元になる数値の配列
     * @returns {number[]} 重複しない乱数を追加した数値の配列
     */
    static getAddNewNumArr(min, max, [...numArr] = []) {
        while (true) {
            const num = this.getRandom(min, max);
            if (numArr.some(val => val == num)) continue;
            numArr.push(num);
            break;
        }

        return numArr;
    }

    /**
     * オブジェクトを深く凍結して取得
     * @param {any} obj 凍結するオブジェクト
     * @returns {any} 凍結したオブジェクト
     */
    static getDeepFreezeObj(obj) {
        const prop = Object.getOwnPropertyNames(obj);

        for (const i in prop) {
            const val = obj[prop[i]];
            if (!val || typeof val != 'object') continue;
            this.getDeepFreezeObj(val);
        }

        return Object.freeze(obj);
    }

    /**
     * 要素のインデックスを取得
     * @param {any} $target インデックスを取得する要素
     * @returns {number} 指定した要素のインデックス
     */
    static getElIndex($target) {
        return [...$target.parentNode.children].indexOf($target);
    }

    /**
     * メディアクエリーの結果を取得
     * @param {string|number} size ブレークポイントのサイズ
     * @param {string} prefix 最小（min）／最大（max）
     * @returns {boolean} メディアクエリーの結果
     */
    static getMedia(size = 'wide', prefix = 'min') {
        typeof size == 'string' && (size = CONFIG.BREAKPOINT[prefix][size]);

        return window.matchMedia(`(${prefix}-width: ${size}px)`).matches;
    }

    /**
     * 範囲を指定して乱数を取得
     * @param {number} min 範囲の最小値
     * @param {number} max 範囲の最大値
     * @param {number} digit 小数点以下の桁数
     * @returns {number} 乱数
     */
    static getRandom(min, max, digit) {
        let num = Math.random() * (max - min + 1) + min;
        num = digit ? Math.floor(num * Math.pow(10, digit)) / Math.pow(10, digit) : Math.floor(num);

        return num;
    }

    /**
     * 配列をシャッフルして取得
     * @param {any[]} arr 文字列／数値等の配列
     * @returns {any[]} シャッフルした配列
     */
    static getShuffleArr([...arr]) {
        for (let i = arr.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }

        return arr;
    }

    /**
     * 日付の配列を並び替えして取得
     * @param {string[]} dateArr 日付の配列
     * @param {string} order 昇順（asc）／降順（desc）
     * @returns {string[]} 並び替えした日付の配列
     */
    static getSortDateArr([...dateArr], order = 'asc') {
        let compare;

        order == 'asc' && (compare = (a, b) => new Date(a) - new Date(b));
        order == 'desc' && (compare = (a, b) => new Date(b) - new Date(a));

        return dateArr.sort(compare);
    }

    /**
     * 数値の配列を並び替えして取得
     * @param {number[]} numArr 数値の配列
     * @param {string} order 昇順（asc）／降順（desc）
     * @returns {number[]} 並び替えした数値の配列
     */
    static getSortNumArr([...numArr], order = 'asc') {
        let compare;

        order == 'asc' && (compare = (a, b) => a - b);
        order == 'desc' && (compare = (a, b) => b - a);

        return numArr.sort(compare);
    }

    /**
     * 数値をゼロパディング形式に変換して取得
     * @param {number} num 数値
     * @param {number} digit 桁数
     * @returns {string} ゼロパディング形式の文字列
     */
    static getZeroStr(num, digit) {
        return String(num).padStart(digit, 0);
    }

    /**
     * ユーザーエージェントから PC／SP の判定結果を取得
     * @param {boolean} tab タブレットも含めるか否か
     * @returns {string[]} 判定結果
     */
    static isMobile(tab) {
        const regex = tab ? /(iPhone|iPad|iPod|Android)/i : /(iPhone|iPod|Android.*Mobile)/i;

        return navigator.userAgent.match(regex);
    }

    /**
     * 交差する要素を監視
     * @param {any} $target 監視する要素
     * @param {function} callback コールバック関数
     * @param {any} options オプション（https://developer.mozilla.org/ja/docs/Web/API/IntersectionObserver/IntersectionObserver）
     */
    static observeIntersection($target, callback, options) {
        const intersection = new IntersectionObserver(callback, options);

        intersection.observe($target);
    }

    /**
     * DOM の変化を監視
     * @param {any} $target 監視する要素
     * @param {function} callback コールバック関数
     * @param {any} options オプション（https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe）
     */
    static observeMutation($target, callback, options) {
        const mutation = new MutationObserver(callback);

        mutation.observe($target, options);
    }
}
